import { StyleSheet } from 'react-native';
import Theme from 'Theme';

const baseStyles = {
    container: {},
    textInput: {
        position: 'relative',
        fontFamily: Theme.regularFont,
        alignSelf: 'stretch',
        backgroundColor: '#FFFFFF',
        fontSize: 20,
        color: '#333333',
        padding: 10,
        borderRadius: 4,
        justifyContent: 'center',
        alignItems: 'center'
    },
    cancelIconContainer: {
        position: 'absolute',
        right: '3%',
        height: '100%',
        alignItems: 'center',
        justifyContent: 'center',
        flexDirection: 'column'
    },
    cancelIcon: {
        width: 20,
        height: 20
    }
};

export const { placeholderTextColor } = Theme;
export default StyleSheet.create(baseStyles);
